import { useTranslation } from 'react-i18next';

import resetIcon from '/resetIcon.svg';

interface ResetButtonProps {
  resetData: () => void;
}

export const ResetButton = ({ resetData }: ResetButtonProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-center my-8 my-6 font-medium text-primary md:mb-0 md:mt-6">
      <button
        type={'reset'}
        className="cursor-pointer flex items-center"
        onClick={resetData}
      >
        <span className="mr-3">
          <img src={resetIcon} alt="" />
        </span>
        {t('resetData')}
      </button>
    </div>
  );
};
